import { redoCartCheckoutIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

// Saves a non-OMS merchant's entered shipping address on the checkout: verifies
// it via EasyPost (US-only), attaches it as the custom destination, and computes
// + saves the tax quote. Throws on verification failure / non-US.
export const setSuppliesCheckoutShippingAddress = {
  name: "setSuppliesCheckoutShippingAddress" as const,
  input: z.object({
    checkoutId: redoCartCheckoutIdFormat.schema,
    address: z.object({
      name: z.string(),
      address1: z.string(),
      address2: z.string().nullable(),
      city: z.string(),
      province: z.string(),
      zip: z.string(),
      countryCode: z.string(),
      phone: z.string().nullable(),
    }),
  }),
  output: z.object({}),
};
